/* unplugin-vue-components disabled */import { render } from "./Banner.vue?vue&type=template&id=565743fd&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=565743fd&lang=scss&scoped=true"

import exportComponent from "../../../../../../../common/temp/node_modules/.pnpm/vue-loader@17.2.2_3tnefydtqxjg44ddub7xm4i2wi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565743fd"]])

export default __exports__